import React from 'react';
import Container from 'common/components/UI/Container';
import { DOCS_LINKS } from 'common/data/launch';
import { Intro } from '../SavingsWorkspace/savingsworkspace.style';
import { PrivacyWrapper, PrivacyList, Closing } from './privacytrust.style';

const ITEMS = [
  {
    lead: 'Registration.',
    text:
      'To register, the app sends your e-mail address, a machine identifier and the plan you chose to our licensing service.',
  },
  {
    lead: 'License check.',
    text:
      'At every start, CloudPouch validates your license with our licensing service. The request carries your license key, a machine identifier and the application version. The app has no offline mode, so it needs this check to start.',
  },
  {
    lead: 'Updates.',
    text:
      'At start, CloudPouch checks GitHub Releases for a newer version. When there is one, it downloads it from GitHub and installs it when you quit the app.',
  },
  {
    lead: 'Error reports.',
    text:
      'Nothing is sent unless you choose to send a report, and you see what it contains first. A report can include AWS resource names, and CloudPouch retains the reports it receives.',
  },
  {
    lead: 'Your AI assistant.',
    text:
      'If you turn on Agentic FinOps, the assistant you connect decides where the answers it reads go next.',
  },
];

const PrivacyTrustSection = () => (
  <PrivacyWrapper id="privacy">
    <Container>
      <Intro>
        <span>PRIVACY AND TRUST</span>
        <h2>Local first, with the exceptions spelled out</h2>
        <p>
          CloudPouch runs on your computer and talks to AWS directly. Good to
          know:
        </p>
      </Intro>
      <PrivacyList>
        {ITEMS.map((item) => (
          <li key={item.lead}>
            <strong>{item.lead}</strong> {item.text}
          </li>
        ))}
      </PrivacyList>
      <Closing>
        <a href={DOCS_LINKS.privacy}>Read the privacy details</a>
      </Closing>
    </Container>
  </PrivacyWrapper>
);

export default PrivacyTrustSection;
